module.exports = __webpack_public_path__ + "img/right2.8c206a24.png";